var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound44D = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 12,
  fill: "#464D57"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m44.85 8.08 7.07 7.07-5.318 6.383a2.5 2.5 0 0 1-3.689.167L38.3 17.087a2.5 2.5 0 0 1 .167-3.689l6.382-5.318Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m42.728 8.787.472-.158a2.812 2.812 0 0 1 2.878.68l4.613 4.613a2.813 2.813 0 0 1 .68 2.878l-.158.472"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m15.15 51.92-7.07-7.07 5.318-6.383a2.5 2.5 0 0 1 3.689-.167l4.613 4.614a2.5 2.5 0 0 1-.167 3.688l-6.382 5.318Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m17.272 51.213-.472.158a2.813 2.813 0 0 1-2.878-.68l-4.613-4.613a2.813 2.813 0 0 1-.68-2.878l.158-.472"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m8.08 15.15 7.07-7.07 6.383 5.318a2.5 2.5 0 0 1 .167 3.689L17.087 21.7a2.5 2.5 0 0 1-3.689-.167L8.08 15.151Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8.787 17.272-.158-.472a2.812 2.812 0 0 1 .68-2.878l4.613-4.613a2.813 2.813 0 0 1 2.878-.68l.472.158"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m51.92 44.85-7.07 7.07-6.383-5.318a2.5 2.5 0 0 1-.167-3.689l4.614-4.613a2.5 2.5 0 0 1 3.688.167l5.318 6.382Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m51.213 42.728.158.472a2.813 2.813 0 0 1-.68 2.878l-4.613 4.613a2.813 2.813 0 0 1-2.878.68l-.472-.158"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m34.895 21-3.63 13.381h-.143L27.659 21H24l4.909 17.36h2.683l4.96-17.351L34.895 21Z"
})));
SvgRound44D.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound44D);
export default ForwardRef;